import { observer } from "mobx-react-lite";
import { useNotificationStore } from "providers/RootStoreProvider";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Topbar from "./Topbar";
import { Card, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import DOMPurify from "dompurify";
import moment from "moment";
import { isThisMonth, isToday } from "utils/date";
import InfoAndSupportTabs from "components/infoandsupport/InfoAndSupportTabs";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  shape: {
    backgroundColor: theme.palette.secondary.main,
    width: 14,
    height: 14,
  },
  shapeCircle: {
    borderRadius: "50%",
  },
}));

const InfoAndSupport = observer(() => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  const notificationStore = useNotificationStore();
  const circle = <div className={clsx(classes.shape, classes.shapeCircle)} />;
  const lang = i18n.language;
  useEffect(() => {
    notificationStore.getNotifications();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const timer = window.setTimeout(() => {
      notificationStore.markNotificationsAsRead();
    }, 5000);
    return () => {
      // Return callback to run on unmount.
      window.clearInterval(timer);
    };
  }, [notificationStore.notifications]);

  return (
    <>
      <Topbar
        title={t("Info and Support")}
        subtitle={t("View information and support materials")}
        breadcrumb={t("Info and Support")}
      />
      <Box py={{ xs: 2, md: 4 }} px={{ xs: 2, md: 4 }}>
        <InfoAndSupportTabs />
      </Box>
    </>
  );
});

export default InfoAndSupport;
